import MiniCssExtractPlugin from 'mini-css-extract-plugin';

export default (opts = {}) => (
  new MiniCssExtractPlugin({
    filename: '[name]-[hash].css',
    sourceMapFilename: '[file].map',
    chunkFilename: '[id]-[chunkhash].css',
    ...opts,
  })
);
